import { Component, Input, OnChanges } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';

@Component({
    selector: 'app-activation-success',
    templateUrl: './activation-success.component.html',
    styleUrls: ['./activation-success.component.scss'],
    standalone: false
})
export class ActivationSuccessComponent extends CfetBaseComponent implements OnChanges {

    displaySuccessMessage: boolean;
    displaySuccessMessage1: boolean;
    displaySuccessMessage2: boolean;
    nfnSuccessData: any;
    tokenData: any = {};
    tempData: any = {};
    userDetails: any;
    showSubPaidUser = false;
    @Input() userRoleList: any;

    constructor() { super(); }


    ngOnChanges() {
        if (this.userRoleList && this.userRoleList.indexOf('G_FN_VOL') !== -1) {
            this.showSubPaidUser = true;
        } else {
            this.showSubPaidUser = false;
        }
    }

    goToFirstnet(): void {
        this.tokenData = sessionStorage.getItem('ngStorage-savedData') ? JSON.parse(sessionStorage.getItem('ngStorage-savedData')) : '';
        if (this.tokenData && this.tokenData.action === 'fedProfileActivated') {
            this.tempData = this.tokenData;
            sessionStorage.removeItem('ngStorage-savedData');
        }
    }
}
